import { provideState } from '@ngrx/store';
import { flyoutFeatureKey, flyoutReducer } from './flyout.reducer';
import { EnvironmentProviders } from '@angular/core';

export const provideFlyoutStore = (): EnvironmentProviders[] => [provideState(flyoutFeatureKey, flyoutReducer)];
